import { SET_RELATED_USERS } from './types';

const initialState = [];

export const relatedUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RELATED_USERS:
      return action.payload;
    default:
      return state;
  }
};
